<template>
    <v-autocomplete v-model="select" :items="items" :rules="rules" :label="label" :color="color" :item-text="itemText" :item-value="itemValue" @change="changeValue" :disabled="disabled" dense outlined></v-autocomplete>
</template>
<script>export default {
  name: "RyouAutocomplete",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    itemText: {
      type: String,
      required: false
    },
    itemValue: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
      },
      rules: {
          type: Array,
          required: false,
          default: () => []
      },
  },
  data() {
    return {};
  },
  method: {},
  methods: {
    changeValue() {
      this.$emit("selectValue", this.select);
    }
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};</script>

<style>
</style>
